import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Title$1 = Typography;

var Container = function Container(_ref) {
  var avatar = _ref.avatar,
      title = _ref.title,
      _ref$vertical = _ref.vertical,
      vertical = _ref$vertical === void 0 ? false : _ref$vertical,
      children = _ref.children,
      additionalAvatarContainerProps = _ref.additionalAvatarContainerProps,
      additionalBodyProps = _ref.additionalBodyProps,
      rest = _objectWithoutPropertiesLoose(_ref, ["avatar", "title", "vertical", "children", "additionalAvatarContainerProps", "additionalBodyProps"]);

  var rootProps = {
    display: 'flex',
    m: 1
  };
  var avatarContainerProps = {
    m: 0
  };
  var bodyProps = {
    ml: 2
  };

  if (vertical) {
    rootProps.display = 'inline-flex';
    rootProps.flexDirection = 'column';
    rootProps.alignItems = 'center';
    rootProps.textAlign = 'center';
    bodyProps.ml = 0;
    bodyProps.mt = 1;
  }

  if (React.Children.count(children) === 0) {
    rootProps.alignItems = 'center';
    rootProps.textAlign = 'center';
    bodyProps.ml = 0;
    bodyProps.mt = 1;
  }

  return /*#__PURE__*/React.createElement(Box, _extends({}, rootProps, rest), /*#__PURE__*/React.createElement(Box, _extends({}, avatarContainerProps, additionalAvatarContainerProps), avatar), /*#__PURE__*/React.createElement(Box, _extends({
    flexGrow: 1
  }, bodyProps, additionalBodyProps), title, /*#__PURE__*/React.createElement(Box, {
    color: "text.secondary"
  }, children)));
};

Container.propTypes = {
  avatar: PropTypes.node.isRequired,
  title: PropTypes.node.isRequired,
  vertical: PropTypes.bool,
  children: PropTypes.any,
  additionalAvatarContainerProps: PropTypes.object,
  additionalBodyProps: PropTypes.object
};

var Title = Title$1;

export default Container;
export { Title };
//# sourceMappingURL=index.module.js.map
